import {
  Stack,
} from "@mui/material";

import SwitchMandate from "./SwitchMandate/SwitchMandate";
import ChangeLanguage from "./ChangeLanguage";
import TopMenuLogout from "./TopMenuLogout";



export default function TopNavbar() {

  return (
    <Stack
      className="top-bar"
      direction="row"
      spacing={1}
      sx={{ width: "100%", height: "50px" }}
      justifyContent="flex-end"
    >

      <Stack direction="row" spacing={1.4} justifyContent="right" alignItems="center">
        <SwitchMandate />
        <ChangeLanguage />
        <TopMenuLogout /> 
      </Stack>
    </Stack>
  );
}
